import { useUserId } from "../../../../query/hooks/helpers";
import { useMutationUpdateActivity } from "../../../../query/users/mutations";
import { FormPayrollSettings } from "../../components/FormPayrollSettings";

import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const PayrollSchedule: React.FC<FlowStep> = ({ title, onNext }) => {
  const userId = useUserId();

  const [updateActivity] = useMutationUpdateActivity(userId);

  const updateActivityAndContinue = async () => {
    await updateActivity({
      flows: {
        onboardingPayrollSettings: {
          complete: true
        }
      }
    });
    onNext?.();
  };

  return <FormPayrollSettings onSuccess={updateActivityAndContinue} />;
};
